import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const MagicWandIcon = createIcon({
  displayName: 'MagicWandIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M18.63,5.37l0.72,-0.72"></path>
        <path d="M19.37,14.39l-0.76,-0.77"></path>
        <path d="M10.36,5.37l-0.72,-0.72"></path>
        <path
          fillRule="evenodd"
          d="M4.205,21.207l-1.412,-1.413c-0.391,-0.391 -0.391,-1.024 0,-1.415l9.577,-9.581c0.391,-0.391 1.024,-0.391 1.414,0l1.412,1.413c0.391,0.391 0.391,1.024 0,1.415l-9.577,9.581c-0.39,0.391 -1.023,0.391 -1.414,0Z"
        ></path>
        <path fillRule="evenodd" d="M13.2,13.62l-2.83,-2.82"></path>
        <path d="M14.49,3.52v-1.02"></path>
        <path d="M20.48,9.51h1.02"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const MagicWand: FC<IconProps> = (props) => {
  return <CustomIcon as={MagicWandIcon} {...props} />
}

export default memo(MagicWand)
